export default "__VITE_ASSET__CTOsdHIm__"